module.exports = __webpack_public_path__ + "static/media/01.1f3126f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/project/lacasadelturbo/01.png
// module id = 150
// module chunks = 0